/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { Button, Tooltip } from "@bigbinary/neeto-atoms";
import { Download } from "lucide-react";
import { isPresent } from "neetocist";
import { useTranslation } from "react-i18next";

const DownloadButton = ({
  count,
  onClick,
  "data-testid": dataTestid = "download-button",
  tooltipProps = {},
}) => {
  const { t } = useTranslation();

  const { content: tooltipContent, ...restTooltipProps } = tooltipProps;

  const resolvedTooltipContent =
    tooltipContent ?? t("neetoMolecules.common.download");

  return (
    <div className="relative">
      <Tooltip
        content={resolvedTooltipContent}
        position="bottom"
        {...restTooltipProps}
      >
        <Button
          {...{ onClick }}
          data-testid={isPresent(dataTestid) ? dataTestid : "download-button"}
          icon={Download}
          size="icon"
          variant="ghost"
        />
      </Tooltip>
      {count && (
        <span className="bg-primary text-primary-foreground absolute -end-0.5 -top-0.5 z-[1] inline-flex min-h-4 min-w-4 items-center justify-center rounded-full text-[0.625rem]">
          {count}
        </span>
      )}
    </div>
  );
};

export default DownloadButton;
